import React, { createContext, useCallback, useEffect, useState } from 'react'
import { getToken } from 'services/auth'
import { UsersService } from 'services/users'

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [ user, setUser ] = useState(null)

  const $user = useCallback(async () => {
    try {
      const { data } = await UsersService.getUserData()
      setUser(data)
    } catch {
      setUser(null)
    }
  }, [])

  useEffect(() => {
    const token = getToken()

    if (!token || token.length === 0)
      return

    $user()
  }, [$user])

  return (
    <AuthContext.Provider
      value={{
        user,
        $user,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
